import _ from 'lodash';

import { getGravatarUrl } from '@zapier/common-utils';
import {
  EntityActions,
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

import * as Account from './Account';

import partialWithDefault from '../utils/partialWithDefault';

export const type = 'member';

export const api = buildEntityApi(type, (path, getState) => {
  const currentAccountId = Account.selectors.all.currentAccountId(getState());
  return `/api/v3/accounts/${currentAccountId}/members/${path}`;
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.avatarUrl = _.flow(_.partial(sel.dataItem, 'email_hash'), getGravatarUrl);
  sel.email = partialWithDefault(sel.dataItem, ['email'], '');
  sel.id = partialWithDefault(sel.dataItem, ['id'], '');
  sel.name = partialWithDefault(sel.dataItem, ['name'], '');
  sel.role = _.partial(sel.dataItem, 'role');
  const hasRole = (role, entity) => sel.role(entity) === role;
  sel.isSuperAdmin = _.partial(hasRole, 'super_admin');
  sel.isAdmin = entity => sel.isAdmin(entity) || sel.isSuperAdmin(entity);
  sel.isOwner = _.partial(hasRole, 'owner');
  sel.normalizedName = entity => {
    // we have to trim the name first since it will come in as ' ' when it is empty
    return (sel.name(entity).trim() || sel.email(entity)).trim();
  };
});

export const actions = buildEntityActions(
  type,
  selectors,
  api,
  entityActions => {
    entityActions.loadCollectionIfTeamAccount = (...args) => (
      dispatch,
      getState
    ) => {
      const currentAccount = Account.selectors.all.currentAccount(getState());
      return Account.selectors.isOrWasTeam(currentAccount)
        ? dispatch(entityActions.loadCollection(...args))
        : Promise.resolve();
    };

    entityActions.setMemberRole = (id, role, messages) => dispatch => {
      return dispatch(
        EntityActions.saveEntity(type, () => ({ role }), api.save, messages, id)
      );
    };
  }
);
